import { PrefixedLink } from '@components/prefixed-link'
import React, { ComponentPropsWithoutRef, forwardRef } from 'react'
import Link from 'next/link'

export type LinkProps = ComponentPropsWithoutRef<typeof Link> & {
  label?: string
}

export const AllPurposeLink = forwardRef<HTMLAnchorElement, LinkProps>(({ href, children, ...props }, ref) => {
  const prefetch = href.toString().startsWith('/marketplace') ? false : props.prefetch
  if (href.toString().startsWith('http')) {
    return (
      <a href={href.toString()} target="_blank" rel="noreferrer" ref={ref} {...props}>
        {children}
      </a>
    )
  }

  return (
    <PrefixedLink href={href} ref={ref} {...props} prefetch={prefetch}>
      {children}
    </PrefixedLink>
  )
})
AllPurposeLink.displayName = 'AllPurposeLink'
